class OpportunityDetailsModalController {
  constructor(
    $scope,
    $uibModalInstance,
    $q,
    opportunity,
    modalClass,
    staffUser,
    DateTimeService,
    APIService
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$q = $q;
    this._opportunity = opportunity;
    this.modalClass = modalClass;
    this._staffUser = staffUser;
    this.DateTimeService = DateTimeService;
    this.APIService = APIService;

    this._errors = [];

  }

  set isOnline(val) {
    this._isOnline = val;
  }

  get isOnline() {
    if (this.APIService) {
      return this.APIService.isOnline;
    }
    return false;
  }

  get opportunity() {
    return this._opportunity;
  }

  get staffUser() {
    return this._staffUser;
  }

  get subject() {
    return this.opportunity && this.opportunity.opportunity_invitation_templates_subject;
  }

  get body() {
    return this.opportunity && this.opportunity.opportunity_invitation_templates_body;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default OpportunityDetailsModalController;

